export default __webpack_public_path__ + "static/004-88e35d7db272bc58492695fb954b322e.jpg";